import axios from 'axios';
import config from 'config';
import enums from 'helpers/const';

export default {
  getTokenContract: () => {
    try {
      var provider = window.kambria.wallet.provider;
      var web3 = provider.web3;
      return null;
    } catch (er) {
      return null;
    }
  },

  getKATPrice: (unit = 'vnd') => {
    return new Promise((resolve, reject) => {
      return axios({
        method: 'get',
        url: 'https://api.coingecko.com/api/v3/simple/price',
        params: { ids: 'kambria', vs_currencies: unit },
      })
        .then((re) => {
          if (re.status !== 200) return reject('Network error');
          const {
            data: { kambria },
          } = re;
          if (!kambria[unit]) return reject('Network error');
          return resolve(kambria[unit]);
        })
        .catch((er) => {
          return reject(er);
        });
    });
  },

  getKYTEPrice: (unit = 'vnd') => {
    return new Promise((resolve, reject) => {
      return axios({
        method: 'get',
        url: 'https://api.coingecko.com/api/v3/simple/price',
        params: { ids: 'kambria-yield-tuning-engine', vs_currencies: unit },
      })
        .then((re) => {
          if (re.status !== 200) return reject('Network error');
          const {
            data: { 'kambria-yield-tuning-engine': kyte },
          } = re;
          if (!kyte[unit]) return reject('Network error');
          return resolve(kyte[unit]);
        })
        .catch((er) => {
          return reject(er);
        });
    });
  },

  countConfirmation: (web3, txId, numberOfConfirmation = 6) => {
    return new Promise((resolve, reject) => {
      if (!web3) return reject('Invalid web3 instance');
      if (!txId) return reject('Invalid transaction hash');

      const filter = web3.eth.subscribe('newBlockHeaders', function (er, blockHeader) {
        if (er) return reject(er);

        return web3.eth.getTransaction(txId, (er, gettedTx) => {
          if (er) return reject(er);

          if (!gettedTx) {
            // Transaction is stale
            filter.unsubscribe();
            console.log('Transaction failed!...');
            return reject(enums.ERROR_STALE_TRANSACTION_ID);
          }

          if (!gettedTx.blockNumber) return null; // Waiting for the first confirmation
          const confirmed = blockHeader.number - gettedTx.blockNumber;
          if (confirmed < numberOfConfirmation) return null; // Waiting for meeting the basic requirements

          filter.unsubscribe();
          console.log('Getted Transaction:', gettedTx);
          return resolve(gettedTx.hash);
        });
      });
    });
  },

  viewTransaction: (txId) => {
    return config.eth.explorer + 'tx/' + txId;
  },
};
